import React, { useEffect, useState } from 'react';
import './ChatRoomsPage.css';
import { API_BASE_URL } from '../api/config';


function statusBadge(status) {
  if (status === 'COMPLETED') return <span className="app-badge completed">완료</span>;
  if (status === 'CONFIRMED') return <span className="app-badge confirmed">확정</span>;
  return <span className="app-badge open">모집중</span>;
}

function ChatRoomsPage({ username, onEnterChatRoom, onBack }) {
  const [chatRooms, setChatRooms] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchChatRooms() {
      setLoading(true);
      try {
        const res = await fetch(
          `${API_BASE_URL}/api/chatrooms?username=${encodeURIComponent(username)}`
        );
        if (!res.ok) throw new Error('채팅방 목록을 불러올 수 없습니다.');
        const data = await res.json();
        setChatRooms(Array.isArray(data) ? data : []);
      } catch (e) {
        setError(e.message);
        setChatRooms([]);
      } finally {
        setLoading(false);
      }
    }
    if (username) fetchChatRooms();
  }, [username]);

  return (
    <div className="app-shell">
      <aside className="app-sidebar">
        <img src="/images/logoTextWhite.png" alt="공구나라" className="app-sidebar-logo" />
      </aside>

      <main className="app-main">
        <div className="app-card">
          <div className="app-card-header">
            <button type="button" className="app-back" onClick={onBack}>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <polyline points="15 18 9 12 15 6" />
              </svg>
              <span>목록</span>
            </button>
            <h2 className="app-card-title">내 채팅방</h2>
          </div>

          <div className="app-card-body">
            {loading && <div className="app-empty">불러오는 중…</div>}
            {!loading && chatRooms.length === 0 && (
              <div className="app-empty">참여한 채팅방이 없습니다.</div>
            )}

            {!loading && chatRooms.length > 0 && (
              <ul className="chatroom-list">
                {chatRooms.map((room) => (
                  <li key={room.id} className="chatroom-item">
                    <div className="chatroom-info">
                      <div className="chatroom-name">{room.name}</div>
                      <div className="chatroom-meta">
                        {statusBadge(room.groupStatus)}
                        {room.groupStatus === 'CONFIRMED' && room.confirmedDate && (
                          <span>확정일 {room.confirmedDate}</span>
                        )}
                        {room.meetupDate && <span>만남 {room.meetupDate}</span>}
                      </div>
                    </div>
                    <button
                      type="button"
                      className="app-btn"
                      onClick={() => onEnterChatRoom?.(room.id, room.name)}
                    >
                      입장
                    </button>
                  </li>
                ))}
              </ul>
            )}

            {error && <div className="app-error">{error}</div>}
          </div>
        </div>
      </main>
    </div>
  );
}

export default ChatRoomsPage;
